import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Autocomplete,
  Grid,
  LinearProgress,
  Typography,
  TextField,
  FormControlLabel,
  Checkbox,
  Backdrop,
  CircularProgress,
  Radio
} from '@mui/material';
import ThemeCustomization from 'src/themesNew';
import { useTheme, ThemeProvider } from '@mui/material/styles';
import React, { useState, useEffect } from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { PatternFormat } from 'react-number-format';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import EmailTwoToneIcon from '@mui/icons-material/EmailTwoTone';
import axios from 'src/utils/axios';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Alert from 'src/components/Alert';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { getUser } from 'src/utils/Common';
import InputAdornment from '@mui/material/InputAdornment';
import SubCard from 'src/components/cards/SubCard';
import Avatar3 from 'src/assets/images/users/avatar-3.png';
import { parse } from 'date-fns';
import { makeStyles } from '@material-ui/styles';
import { createTheme } from '@material-ui/core';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },

}));

function LinearProgressWithLabel({ value, ...others }) {
  const theme = useTheme();

  return (
    <ThemeCustomization>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <Box
          sx={{
            width: '100%',
            mr: 1
          }}
        >
          <LinearProgress value={value} {...others} />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" color="textSecondary">{`${Math.round(value)}%`}</Typography>
        </Box>
      </Box>
    </ThemeCustomization>
  );
}

LinearProgressWithLabel.propTypes = {
  value: PropTypes.number
};
function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const DefaultConsumerAndRetailerValue = {
  Active: 0,
  Adress: '',
  BankAccountNumber: 0,
  BirthDate: '',
  BirthPlace: '',
  CellPhone: '',
  DateofDeparture: '',
  DateofEntrance: '',
  Department: '',
  DepartureReason: '',
  DepartureReasonId: 0,
  Description: '',
  District: '',
  DriverLicense: '',
  Education: '',
  EducationId: 0,
  Email: '',
  MernisNumber: 0,
  MilitaryStatus: '',
  MilitaryStatusId: 0,
  Name: '',
  PersonelKocAilemStatus: 0,
  PersonelNo: 0,
  PersonelRandevuAtanabilir: 0,
  PersonelType: '',
  PersonelTypeId: 0,
  ServiceShop: '',
  ServiceShopCode: '',
  ServiceShopId: 0,
  Sex: '',
  SexId: 0,
  State: '',
  StateId: 0,
  Surname: '',
  TechnicianCode: '',
  TechnicianId: 0,
  TeknisyenStatus: 0,
  TeknisyenStatusVisible: 0,
  OrganizationTypeId: 1
};

// ==============================|| PROFILE 1 - PROFILE ||============================== //

const Profile = ({ EmployeeNr, OrganizationTypeId, OrganizationId, NewEmployeeGet }) => {
  const theme = useTheme();
  const [employeeNo, setEmployeeNo] = useState(EmployeeNr);
  const [genderData, setGenderData] = useState([]);
  const [educationData, setEducationData] = useState([])
  const [existTypeData, setExistTypeData] = useState([]);
  const [employeeTypeData, setEmployeeTypeData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [districtData, setDistrictData] = useState([]);
  const [drivingLicenseData, setDrivingLicenseData] = useState([]);
  const [Yetki, setYetki] = useState([]);
  const [avatarEmployee, setAvatarEmployee] = useState(Avatar3);
  const [formData, setFormData] = useState(DefaultConsumerAndRetailerValue);
  const [ValidControlColor, setValidControlColor] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(0);
  const [AlertPopup, setAlertPopup] = useState(false);
  const [AlertType, setAlertType] = useState('default');
  const [AlertDescription, setAlertDescription] = useState("");
  const [loadingCombo, setLoadingCombo] = useState(true);
  const [dateofEntranceVal, setDateofEntranceVal] = useState(null);
  const [dateofDepartureVal, setDateofDepartureVal] = useState(moment(null));
  const [sex, setSex] = useState(null)

  const genderOptions = [
    { Id: 0, Dsc: 'Erkek' },
    { Id: 1, Dsc: 'Kadın' }
  ]

  const classes = useStyles();
  const SessionUser = getUser();
  const redFlag = createTheme({
    components: {
      MuiFormLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
        },
      },
    },

  })

  function isValidEmail(email) {
    var re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
    return re.test(email);
  }


  const handleSave = () => {
    const regex = /^[a-zA-ZığüşöçĞÜŞÖÇİ\s]*$/;
    if (!regex.test(formData?.Name) || !regex.test(formData?.Surname)) {
      setAlert('error', 'İsim ve Soyisim alanları sadece harf içermelidir.');
      return;
    }
    if (!isValidEmail(formData?.Email)) {
      setAlert('error', 'Lütfen geçerli bir eposta adresi giriniz!.');
      return;
    }
    if ([4, 5].includes(SessionUser?.ManagementRoleId) && isChecked == false) {
      setAlert('error', 'Lütfen özlük dosyası hukuki yükümlülüklere onay veriniz!.');
      return;
    }
    if (OrganizationTypeId === 2 && (formData?.SexId === null || formData?.SexId === undefined || formData?.SexId === 3)) {
      setAlert('error', 'Lütfen cinsiyet bilgisini giriniz!.');
      return;
    }
    confirmAlert({
      message: "Değişiklikleriniz kaydedilecektir!... Devam etmek istediginizden emin misiniz?",
      buttons: [
        {
          label: 'Evet',
          onClick: () => handleSaveYes()
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
  };

  const isNumeric = (value) => {
    return !isNaN(value) && !isNaN(parseFloat(value));
  };

  const handleSaveYes = () => {
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    const requestData = {
      ...formData,
      OrganizationTypeId: OrganizationTypeId,
      UserId: "", RoleId: SessionUser?.ManagementRoleId,
      permission: +isChecked
    };

    if (dateofEntranceVal && formData?.DateofEntrance === "Invalid date") {
      setAlert('error', 'Giriş Tarihi geçersiz.');
      return;
    }
    if (dateofDepartureVal && formData?.DateofDeparture === "Invalid date") {
      setAlert('error', 'Ayrılış Tarihi geçersiz.');
      return;
    }

    setLoading(true);

    axios.post('/SetEmployee', requestData, config)
      .then(response => {
        var data = response.data;
        if (isNumeric(data.toString())) {
          setAlert('success', 'Çalışan bilgileri başarıyla kaydedildi.');
          var employeeNoParam;
          if (employeeNo === 0) {
            employeeNoParam = data.toString();
            NewEmployeeGet(employeeNoParam);
          } else {
            employeeNoParam = employeeNo;
          }
          setEmployeeNo(employeeNoParam);
          GetEmployeeImage();
          axios.get(`GetWorkerInfo/${employeeNoParam}`).then((response) => {
            setYetki(JSON.parse(response?.data[0]?.YETKI));
            setFormData(response.data[0]);
            setIsChecked(response.data[0].permission);
            handleCatalog(response.data[0]?.CityId === undefined ? 0 : response.data[0]?.CityId);
            //handleKVKKQuestions(response.data[0]?.Active);
            setActive(response.data[0]?.Active);
          })
        } else {
          setAlert('error', data);
        }
        setLoading(false);
      });
  }

  const setAlert = (type, description) => {
    setAlertPopup(true);
    setAlertType(type);
    setAlertDescription(description);
  }





  useEffect(() => {
    setLoading(true);
    GetEmployeeImage();
    axios.get(`GetWorkerInfo/${employeeNo}`).then((response) => {
      if (employeeNo === 0) {
        response.data[0].ServiceShopId = OrganizationId;
      }
      setLoading(false);
      setYetki(JSON.parse(response?.data[0]?.YETKI));
      setFormData(response.data[0]);
      setIsChecked(response.data[0].permission);
      setDateofEntranceVal(response.data[0]?.DateofEntrance ? parse(response.data[0]?.DateofEntrance, 'dd.MM.yyyy', new Date()) : null);
      setDateofDepartureVal(response.data[0]?.DateofDeparture ? parse(response.data[0]?.DateofDeparture, 'dd.MM.yyyy', new Date()) : null);
      handleCatalog(response.data[0]?.CityId === undefined ? 0 : response.data[0]?.CityId);
      setActive(response.data[0]?.Active);
    });
    handleCatalog(0);

  }, []);

  const GetEmployeeImage = () => {
    axios.get(`GetEmployeeImage/${employeeNo}`).then((response) => {
      if (response.data.length > 0) {
        setAvatarEmployee(response.data[0].Image);
      } else {
        setAvatarEmployee(Avatar3)
      }
    });
  }

  const handleCatalog = (id) => {
    setLoadingCombo(true);
    axios.get(`GetCatalogItemsForEmployee/${id}/${OrganizationTypeId}`).then((response) => {
      if (response.data.length > 0 && id == 0) {
        const res = response.data[0];
        setGenderData(res.Cinsiyet);
        setEmployeeTypeData(res.CalisanTip);
        setExistTypeData(res.CikisSebebi);
        setEducationData(res.OgrenimDurumu);
        setCityData(res.IL);
        setDrivingLicenseData(res.Ehliyet);
        setLoadingCombo(false);
      } else {
        const res = response.data;
        setDistrictData(res);
        setLoadingCombo(false);
      }
    });
  }
  const handleGenderType = (val) => {
    setFormData({ ...formData, SexId: val.Id })
    setSex(val)
  }
  const handlePersonelType = (val) => {
    setFormData({ ...formData, PersonelTypeId: val.Id });
  }
  const handleEducation = (val) => {
    setFormData({ ...formData, EducationId: val.Id })
  }
  const handleDepartureReason = (val) => {
    setFormData({ ...formData, DepartureReasonId: val?.Id || 0 })
  }
  const handleDrivingLicence = (val) => {
    setFormData({ ...formData, DriverLicenseId: val.Id })
  }
  const handleDateChange = (value) => {
    setFormData({ ...formData, BirthDate: value ? moment(value).format('DD.MM.YYYY') : '' });
  };
  const handleDateChangeEntrance = (value) => {
    setDateofEntranceVal(value);
    setFormData({ ...formData, DateofEntrance: value ? moment(value).format('DD.MM.YYYY') : '' });
  };
  const handleDateChangeDeparture = (value) => {
    setDateofDepartureVal(value);
    setFormData({ ...formData, DateofDeparture: value ? moment(value).format('DD.MM.YYYY') : '' });
  };
  const validateEmail = event => {
    var email = event.target.value;
    setFormData({ ...formData, Email: event.target.value });
  };
  const setFormDataName = event => {
    NewEmployeeGet(-1, event.target.value, formData?.Surname, formData.StateId);
    setFormData({ ...formData, Name: event.target.value })
  }
  const setFormDataSurName = event => {
    NewEmployeeGet(-1, formData?.Name, event.target.value, formData.StateId);
    setFormData({ ...formData, Surname: event.target.value })
  }
  const setFormDataStatus = event => {
    NewEmployeeGet(-1, formData?.Name, formData?.Surname, formData.StateId ? 0 : 1);
    if (formData.StateId === 0 && event.target.checked == 1) {
      if (formData.hasOwnProperty('DepartureReasonId')) {
        delete formData.DepartureReasonId;
        Object.assign(formData, {
          DepartureReasonId: 0
        })
      }
      if (formData.hasOwnProperty('DateofDeparture')) {
        delete formData.DateofDeparture;
        Object.assign(formData, {
          DateofDeparture: ''
        })
        setDateofDepartureVal('');
      }
    }
    setFormData({
      ...formData,
      StateId: formData.StateId ? 0 : 1
    });

  }

  const AlertClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertPopup(false);
  };


  // const handleKVKKQuestions = (employeeStatus) => {
  //   if (employeeStatus !== active && employeeStatus == 0) {
  //     confirmAlert({
  //       message: "Çalışan pasif hale getirildi. Çalışanın KVKK iznini iptal etmek ister misiniz?",
  //       buttons: [
  //         {
  //           label: 'Evet',
  //           onClick: () => handleSetEmployeeKvkkPassive()
  //         },
  //         {
  //           label: 'Hayır',
  //           onClick: () => { return; }
  //         }
  //       ]
  //     });
  //   }
  // }

  // const handleSetEmployeeKvkkPassive = () => {
  //   axios.get(`SetEmployeeKvkkPassive/${SessionUser?.ManagementRoleId}/${employeeNo}`).then((response) => {
  //     if (response.data.ErrorCode === "0") {
  //       setAlert('success', 'Çalışanın KVKK izni başarılı bir şekilde iptal edildi.');
  //     } else {
  //       setAlert('error', 'Bir hata meydana geldi');
  //     }
  //   });
  // }

  const [isChecked, setIsChecked] = useState(false);

  return (
    <div>
      {
        loading ?
          <Backdrop className={classes.backdrop} open={loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          : <div></div>
      }
      <ThemeCustomization>
        <ThemeProvider theme={redFlag}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Grid container spacing={1}>
              <Grid item lg={12} xs={12}>
                <div>
                  {
                    AlertPopup ?
                      <Typography align="left">
                        <Alert onClose={AlertClose} open={AlertPopup} message={AlertDescription || ''} variant={AlertType} />
                      </Typography>
                      : <div></div>
                  }
                </div>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6} md={4}>
                    <SubCard title="Personel Çalışan Kimlik Bilgileri" style={{ minHeight: 400 }}>
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={OrganizationTypeId != 2 ? 4 : 6}>
                          <TextField
                            label="Eleman No"
                            value={employeeNo}
                            fullWidth
                            disabled={true}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={OrganizationTypeId != 2 ? 4 : 6}>
                          <TextField
                            label="Sicil No"
                            value={formData ? formData.SicilNo : ''}
                            onChange={(event) => setFormData({ ...formData, SicilNo: event.target.value })}
                            fullWidth
                            InputProps={{
                              readOnly: true,
                              style: { color: 'red', fontWeight: 'bold' }
                            }}
                            InputLabelProps={{
                              shrink: true, // This ensures the label doesn't overlap with the value
                              style: { color: 'gray', fontWeight: 'normal' }
                            }}
                          />
                        </Grid>
                        {OrganizationTypeId != 2 && (
                          <Grid item xs={12} sm={12} md={4} >
                            <TextField
                              label="Teknisyen No"
                              value={formData ? formData.TechnicianCode : ''}
                              onChange={(event) => setFormData({ ...formData, TechnicianCode: event.target.value })}
                              fullWidth
                              disabled={true}
                            />
                          </Grid>
                        )
                        }
                        <Grid item xs={12} sm={12} md={4}>
                          <TextField
                            required
                            label="İsim"
                            value={formData ? formData.Name : ''}
                            onChange={(event) => setFormDataName(event)}
                            fullWidth
                            autoComplete="no"
                            disabled={Yetki.find(item => item.ALAN_ADI === 'dsName')?.DISABLE_ALAN}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={4}>
                          <TextField
                            required
                            label="Soyisim"
                            value={formData ? formData.Surname : ''}
                            onChange={(event) => setFormDataSurName(event)}
                            disabled={Yetki.find(item => item.ALAN_ADI === 'dsSurname')?.DISABLE_ALAN}
                            fullWidth
                            autoComplete="no"
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} display="flex" justifyContent="center" alignItems="center">
                          <FormControlLabel
                            value="bottom"
                            labelPlacement="bottom"
                            control={<Checkbox
                              checked={formData?.StateId === 1}
                              sx={{
                                color: "#FFA500",
                                '&.Mui-checked': {
                                  color: "#FFA500",
                                },
                              }}
                              size="medium"
                              onChange={(event) => setFormDataStatus(event)}
                            />}
                            disabled={Yetki.find(item => item.ALAN_ADI === 'dsStateId')?.DISABLE_ALAN}
                            label="Aktif/Pasif"
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <Autocomplete
                            options={employeeTypeData}
                            value={employeeTypeData?.find(i => i?.Id == formData?.PersonelTypeId) || 0}
                            getOptionLabel={(i) => i?.Dsc || ""}
                            onChange={(event, val) => handlePersonelType(val)}
                            disabled={Yetki.find(item => item.ALAN_ADI === 'dsPersonelTypeId')?.DISABLE_ALAN}
                            renderInput={(params) => <TextField {...params} label="Çalışan Tipi"
                              required
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {loadingCombo && <CircularProgress color="primary" size={20} />}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }} />}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                          <PatternFormat
                            required
                            format="###########"
                            mask="_"
                            fullWidth
                            customInput={TextField}
                            label="TC Kimlik No"
                            disabled={OrganizationTypeId === 1 || Yetki.find(item => item.ALAN_ADI === 'dsMernisNumber')?.DISABLE_ALAN}
                            value={formData ? formData.MernisNumber : ''}
                            onChange={(event) => setFormData({ ...formData, MernisNumber: event.target.value })}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <TextField
                            label="Doğum Yeri"
                            value={formData ? formData.BirthPlace : ''}
                            disabled={Yetki.find(item => item.ALAN_ADI === 'dsBirthPlace')?.DISABLE_ALAN}
                            onChange={(event) => setFormData({ ...formData, BirthPlace: event.target.value })}
                            fullWidth
                            autoComplete="no"
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <DatePicker
                            required
                            label="Doğum Tarihi"
                            format="dd.MM.yyyy"
                            disabled={Yetki.find(item => item.ALAN_ADI === 'dsBirthDate')?.DISABLE_ALAN}
                            value={formData ? parse(formData?.BirthDate, 'dd.MM.yyyy', new Date()) : null}
                            fullWidth
                            onChange={handleDateChange}
                            renderInput={(params) => <TextField fullWidth {...params} />}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Autocomplete
                            disablePortal
                            options={genderOptions}
                            value={genderOptions.find(i => i?.Id == formData?.SexId) || ''}
                            getOptionLabel={(i) => i?.Dsc || ""}
                            onChange={(event, val) => handleGenderType(val)}
                            fullWidth
                            disabled={Yetki.find(item => item.ALAN_ADI === 'dsSexId')?.DISABLE_ALAN}
                            renderInput={(params) => <TextField {...params} label="Cinsiyet"
                              required
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {loadingCombo && <CircularProgress color="primary" size={20} />}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />}
                          />
                          {OrganizationTypeId == 2 &&
                            <Typography variant='body2'
                              sx={{
                                fontSize: '0.85rem',
                                color: 'text.secondary',
                                fontStyle: 'italic',
                                mt: 1
                              }}>
                              *Bu bilgi yalnızca Toplumsal Cinsiyet Eşitliği Sosyal Sorumluluk Projesi kapsamında analiz çalışmaları yapılması amacıyla toplanmaktadır.
                            </Typography>
                          }
                        </Grid>
                      </Grid>
                    </SubCard>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <SubCard title="İletişim Bilgileri" style={{ minHeight: 400 }}>
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={6}>
                          <TextField
                            required
                            size="medium"
                            id="Email"
                            autoComplete="no"
                            value={formData ? formData?.Email : ''}
                            disabled={Yetki.find(item => item.ALAN_ADI === 'dsEmail')?.DISABLE_ALAN}
                            helperText={emailError}
                            error={ValidControlColor}
                            onChange={event => validateEmail(event)}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <EmailTwoToneIcon />
                                </InputAdornment>
                              ),
                            }}
                            fullWidth
                            label={('Email')}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <PatternFormat
                            required
                            format="(###) ###-####"
                            mask="_"
                            fullWidth
                            value={formData ? formData.CellPhone : ''}
                            disabled={Yetki.find(item => item.ALAN_ADI === 'dsCellPhone')?.DISABLE_ALAN}
                            onChange={(event) => setFormData({ ...formData, CellPhone: event.target.value })}
                            customInput={TextField}
                            label="Cep Telefonu"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <PhoneIphoneIcon />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                          <Autocomplete
                            options={educationData}
                            value={educationData?.find(i => i?.Id == formData?.EducationId) || ''}
                            getOptionLabel={(i) => i?.Dsc || ""}
                            disabled={Yetki.find(item => item.ALAN_ADI === 'dsEducationId')?.DISABLE_ALAN}
                            onChange={(event, val) => handleEducation(val)}
                            fullWidth
                            renderInput={(params) => <TextField {...params} label="Öğrenim"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {loadingCombo && <CircularProgress color="primary" size={20} />}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <DatePicker
                            label="Giriş Tarihi"
                            format="dd.MM.yyyy"
                            disabled={Yetki.find(item => item.ALAN_ADI === 'dsDateofEntrance')?.DISABLE_ALAN}
                            value={dateofEntranceVal}
                            fullWidth
                            onChange={handleDateChangeEntrance}
                            renderInput={(params) => <TextField fullWidth {...params} />}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <DatePicker
                            label="Ayrılış Tarihi"
                            format="dd.MM.yyyy"
                            maxDate={new Date()}
                            disabled={Yetki.find(item => item.ALAN_ADI === 'dsDateofDeparture')?.DISABLE_ALAN}
                            value={dateofDepartureVal}
                            fullWidth
                            onChange={handleDateChangeDeparture}
                            renderInput={(params) => (
                              <TextField
                                fullWidth
                                {...params}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Autocomplete
                            options={existTypeData}
                            value={existTypeData?.find(i => i?.Id == formData?.DepartureReasonId) || ''}
                            getOptionLabel={(i) => i?.Dsc || ""}
                            onChange={(event, val) => handleDepartureReason(val)}
                            disabled={Yetki.find(item => item.ALAN_ADI === 'dsDepartureReasonId')?.DISABLE_ALAN}
                            fullWidth
                            renderInput={(params) => <TextField {...params} label="Ayrılık Sebebi"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {loadingCombo && <CircularProgress color="primary" size={20} />}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={formData?.TeknisyenStatusVisible == 1 ? 3 : 4} display="flex" justifyContent="center" alignItems="center">
                          {formData?.SexId === 0 ?
                            <FormControlLabel
                              value="bottom"
                              labelPlacement="bottom"
                              control={<Checkbox
                                checked={formData?.MilitaryStatusId === 1}
                                disabled={Yetki.find(item => item.ALAN_ADI === 'dsMilitaryStatusId')?.DISABLE_ALAN}
                                sx={{
                                  color: "#FFA500",
                                  '&.Mui-checked': {
                                    color: "#FFA500",
                                  },
                                }}
                                size="medium"
                                onChange={(event) => setFormData({
                                  ...formData,
                                  MilitaryStatusId: formData.MilitaryStatusId ? 0 : 1
                                })}

                              />}
                              label="Askerlik Durumu"
                              fullWidth
                            />
                            : ''}
                        </Grid>
                        {OrganizationTypeId != 2 && (
                          <Grid item xs={12} sm={12} md={formData?.TeknisyenStatusVisible == 1 ? 3 : 4} display="flex" justifyContent="center" alignItems="center">
                            <FormControlLabel
                              value="bottom"
                              labelPlacement="bottom"
                              control={<Checkbox
                                checked={formData?.PersonelKocAilemStatus === 1}
                                disabled={Yetki.find(item => item.ALAN_ADI === 'dsPersonelKocAilemStatus')?.DISABLE_ALAN}
                                sx={{
                                  color: "#FFA500",
                                  '&.Mui-checked': {
                                    color: "#FFA500",
                                  },
                                }}
                                size="medium"
                                onChange={(event) => setFormData({
                                  ...formData,
                                  PersonelKocAilemStatus: formData.PersonelKocAilemStatus ? 0 : 1
                                })}
                              />}
                              label="KoçAilem'li Olabilir"
                            />
                          </Grid>
                        )}
                        {OrganizationTypeId != 2 && (
                          <Grid item xs={12} sm={12} md={formData?.TeknisyenStatusVisible == 1 ? 3 : 4} display="flex" justifyContent="center" alignItems="center">
                            <FormControlLabel
                              value="bottom"
                              labelPlacement="bottom"
                              control={<Checkbox
                                checked={formData?.PersonelRandevuAtanabilir === 1}
                                disabled={Yetki.find(item => item.ALAN_ADI === 'dsPersonelRandevuAtanabilir')?.DISABLE_ALAN}
                                sx={{
                                  color: "#FFA500",
                                  '&.Mui-checked': {
                                    color: "#FFA500",
                                  },
                                }}
                                size="medium"
                                onChange={(event) => setFormData({
                                  ...formData,
                                  PersonelRandevuAtanabilir: formData.PersonelRandevuAtanabilir ? 0 : 1
                                })}

                              />}
                              label="Atama Yapılabilir"
                            />
                          </Grid>
                        )}
                        {formData?.TeknisyenStatusVisible == 1 ?
                          <Grid item xs={12} sm={12} md={3} display="flex" justifyContent="center" alignItems="center">
                            <FormControlLabel
                              value="bottom"
                              labelPlacement="bottom"
                              control={<Checkbox
                                checked={formData?.TeknisyenStatus === 1}
                                disabled={Yetki.find(item => item.ALAN_ADI === 'dsTeknisyenStatus')?.DISABLE_ALAN}
                                sx={{
                                  color: "#FFA500",
                                  '&.Mui-checked': {
                                    color: "#FFA500",
                                  },
                                }}
                                size="medium"
                                onChange={(event) => setFormData({
                                  ...formData,
                                  TeknisyenStatus: formData.TeknisyenStatus ? 0 : 1
                                })}

                              />}
                              label="Teknisyen Olabilir"
                            />
                          </Grid>
                          : null}
                      </Grid>
                    </SubCard>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <SubCard title="Diğer Bilgiler" style={{ minHeight: 400 }}>
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={12}>
                          <Autocomplete
                            disablePortal
                            options={drivingLicenseData}
                            disabled={Yetki.find(item => item.ALAN_ADI === 'dsDriverLicenseId')?.DISABLE_ALAN}
                            value={drivingLicenseData?.find(i => i?.Id == formData?.DriverLicenseId) || ""}
                            getOptionLabel={(i) => i?.Dsc || ""}
                            onChange={(event, val) => handleDrivingLicence(val)
                            }
                            fullWidth
                            renderInput={(params) => <TextField {...params} label="Ehliyet"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {loadingCombo && <CircularProgress color="primary" size={20} />}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <Autocomplete
                            required
                            options={cityData}
                            disabled={Yetki.find(item => item.ALAN_ADI === 'dsCityId')?.DISABLE_ALAN}
                            value={cityData?.find(i => i?.Id == formData?.CityId) || ''}
                            getOptionLabel={(i) => i?.Dsc || ""}
                            onChange={(event, val) => {
                              setFormData({ ...formData, CityId: val.Id })
                              handleCatalog(val.Id)
                            }}
                            fullWidth
                            renderInput={(params) => <TextField {...params} label="Şehir"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {loadingCombo && <CircularProgress color="primary" size={20} />}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }} />}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <Autocomplete
                            required
                            options={districtData}
                            disabled={Yetki.find(item => item.ALAN_ADI === 'dsDistrictId')?.DISABLE_ALAN}
                            value={districtData?.find(i => i?.Id == formData?.DistrictId) || ''}
                            getOptionLabel={(i) => i?.Dsc || ""}
                            onChange={(event, val) => {
                              setFormData({ ...formData, DistrictId: val.Id })
                            }}
                            fullWidth
                            renderInput={(params) => <TextField {...params} label="İlçe"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {loadingCombo && <CircularProgress color="primary" size={20} />}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }} />}
                          />
                        </Grid>
                        {OrganizationTypeId != 2 ?
                          <Grid item xs={12}>
                            <TextField
                              label="Adres"
                              disabled={Yetki.find(item => item.ALAN_ADI === 'dsAdress')?.DISABLE_ALAN}
                              value={formData ? formData.Adress : ''}
                              onChange={(event) => setFormData({ ...formData, Adress: event.target.value })}
                              fullWidth
                              multiline
                              rows={2}
                              autoComplete="no"
                              placeholder="Sokak, Cadde..."
                            />
                          </Grid>
                          : null}
                        <Grid item xs={12}>
                          {Yetki.find(item => item.ALAN_ADI === 'dsDescriptionShow')?.DISABLE_ALAN ? null :
                            <TextField
                              label="Not"
                              disabled={Yetki.find(item => item.ALAN_ADI === 'dsDescription')?.DISABLE_ALAN}
                              value={formData ? formData.Description : ''}
                              onChange={(event) => setFormData({ ...formData, Description: event.target.value })}
                              fullWidth
                              autoComplete="no"
                              multiline
                              rows={2}
                            />
                          }
                        </Grid>
                      </Grid>
                    </SubCard>
                  </Grid>
                  &nbsp;
                  <Grid container spacing={1} justifyContent="right">
                    <Grid item xs={4} style={{ textAlign: "left" }}>
                      {[1, 4, 5].includes(SessionUser?.ManagementRoleId) ?
                        <FormControlLabel
                          control={
                            <Radio
                              checked={isChecked}
                              onClick={() => setIsChecked(!isChecked)}
                              style={{ color: isChecked ? '#FFA500' : 'initial' }}
                            />
                          }
                          label="Bu kişinin özlük dosyasını hukuki yükümlülüklere uygun olarak topladım ve kanunen gerekli süre kadar saklayacağım."
                        />
                        : null}
                      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                          variant="contained"
                          color="secondary"
                          startIcon={<PersonAddIcon />}
                          style={{ textTransform: 'none' }}
                          onClick={handleSave}
                          disabled={Yetki.find(item => item.ALAN_ADI === 'dsProfileSave')?.DISABLE_ALAN}
                        >
                          Kaydet
                        </Button>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </LocalizationProvider>
        </ThemeProvider>
      </ThemeCustomization >
    </div>
  );
};

Profile.propTypes = {
  NewEmployeeGet: PropTypes.func,

};

Profile.defaultProps = {
  NewEmployeeGet: () => { }
};

export default Profile;
